// The plan the customer's ORGANISATION holds for FreightRates, from the API (GET /v1/account/plan). The personal
// profile (frm_profiles.plan) only knows a self-serve purchase made on this site; a plan granted by sales, or paid
// through the workspace, lives on the organisation. The account page shows whichever says "paid".
import { getAccessToken } from './active-session'

const API_BASE =
  (import.meta.env.VITE_API_BASE as string | undefined) || 'https://api.freightratesmcp.com'

export interface OrgPlan {
  active: boolean
  plan: string
  /** Pro, Enterprise, Starter or Free. The product's Pro is stored as 'business'. */
  label: string
  status?: string | null
  /** end of the paid period (ISO); null for a grant with no billing period */
  valid_until?: string | null
  since?: string | null
}

/** Null when signed out, the API is down, or the session is not one the API recognises. Never throws. */
export async function loadOrgPlan(): Promise<OrgPlan | null> {
  try {
    const token = await getAccessToken()
    if (!token) return null
    const res = await fetch(`${API_BASE}/v1/account/plan`, {
      headers: { authorization: `Bearer ${token}` },
    })
    if (!res.ok) return null
    const body = (await res.json()) as { data?: OrgPlan }
    return body.data ?? null
  } catch {
    return null
  }
}
